import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Katrin S.',
  role: 'Vinyasa Teacher',
  location: 'Sydney, Australia',
  quote: 'I finally have my weekends back. I used to spend hours on Pinterest—now I just open the Yoga Ready tab and my sequence and theme are done. My students in Bondi love the new variety.',
  initials: 'KS',
  color: '#8B6FBF'
}, {
  name: 'Michael B.',
  role: 'Studio Owner',
  location: 'Melbourne, Australia',
  quote: 'The therapeutic modification guides are pure gold. They gave me the confidence to handle students with back issues or knee replacements professionally. I’m no longer guessing, I have a plan.',
  initials: 'MB',
  color: '#D4A574'
}, {
  name: 'Sarah L.',
  role: 'Freelance Teacher',
  location: 'Brisbane, Australia',
  quote: 'It’s so much more than a PDF. It’s a complete pedagogical system. I’ve been teaching for 7 years and this kit brought an incredible freshness back to my practice.',
  initials: 'SL',
  color: '#0F8B6F'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-258">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-259"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-260">
        <div className="text-center mb-10 sm:mb-14" data-id="element-261">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-262">
            ⭐ Real Aussie Reviews
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-263">
            What Australian Yoga Teachers are{' '}
            <span className="text-primary" data-id="element-264">saying</span>.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-265">
            <span className="text-[#E0A52E] text-base sm:text-lg" data-id="element-266">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-267">
              4.9/5 (+800 verified Aussie reviews)
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-268">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(90,70,120,0.15)] flex flex-col relative" data-id="element-269">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/15 leading-none select-none" data-id="element-270">
                "
              </span>

              <div className="text-[#E0A52E] text-sm mb-3" data-id="element-271">⭐⭐⭐⭐⭐</div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-272">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-273">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-274">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-275">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-276">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-277">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-278">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-279">
          Over <span className="text-primary font-bold" data-id="element-280">15,000 teachers</span>{' '}
          worldwide are already teaching with YOGA READY.
        </p>
      </div>
    </section>;
}